import React, { Fragment } from "react";
import "./submenu.scss";
import { ImDatabase } from "react-icons/im";
import { SiGoogleanalytics } from "react-icons/si";
import { AiFillClockCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";




export default function SubMenuProdutos() {

  const { t } = useTranslation()

  return (
    <div className="container-submenuProd">
      <div className="submenu-Prod">
        <div className="dados-conectores">
          <div className="title-dadosconectores">
            <h1>
              <ImDatabase /> {t("navbar.produtos_menu.connectors.title")}
            </h1>
          </div>
          <a href="/connectors">
            <p>{t("navbar.produtos_menu.connectors.conectors_link_text")}</p>
          </a>
          <a href="/dataSources">
            <p>{t("navbar.produtos_menu.connectors.datasources_link_test")}</p>
          </a>
          <a href="/dataManagement">
            <p>{t("navbar.produtos_menu.connectors.datamanagement_link_test")}</p>
          </a>
          <a href="/realtimeData">
            {/* realdata_link_test */}
            <p>{t("navbar.produtos_menu.connectors.realdata_link_test")}</p>
          </a>
        </div>
        <div className="dash-relatorio">
          <div className="title-dash">
            <h1>
              <SiGoogleanalytics /> {t("navbar.produtos_menu.dashboards_and_reports.title")}
            </h1>
          </div>
          {/* <p style={{ color: "#00000052" }}>Criando um Dashboard</p> */}
          <a href="/InteractiveDashboards">
            {/* Dashboards Interativos */}
            <p>{t("navbar.produtos_menu.dashboards_and_reports.interactive_dashboard.title")}</p>
          </a>
          <a href="/Reports">
            <p>{t("navbar.produtos_menu.dashboards_and_reports.mobile_dashboards.title")}</p>
          </a>
          <a href="/AgileDashboards">
            <p>{t("navbar.produtos_menu.dashboards_and_reports.dashboard_design.title")}</p>
          </a>

          <a href="/WhiteLabel">
            <p>White Label/OEM</p>
          </a>
        </div>
        <div className="automacao">
          <div className="title-automacao">
            <h1>
              <AiFillClockCircle /> {t("navbar.produtos_menu.automation.title")}
            </h1>
          </div>
          <a href="/publishAndShare">
            <p>{t("navbar.produtos_menu.automation.publish_and_share.title")}</p>
          </a>
          <a href="/scheduling">
            <p>{t("navbar.produtos_menu.automation.scheduling.title")}</p>
          </a>
          <a href="/securityandmanagement">
            <p>{t("navbar.produtos_menu.automation.security_and_management.title")}</p></a>
          <a href="/advancedSecurity">
            <p>{t("navbar.produtos_menu.automation.advanced_security.title")}</p>
          </a>
        </div>
      </div>
    </div>
  );
}
